import React from "react";
import { CiWarning } from "react-icons/ci";

const SubscriptionRenewalPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-4 text-center">
        <div className="flex justify-center">
          <CiWarning className="text-center text-[7rem] text-orange-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Subscription Expired
        </h1>
        <p className="text-gray-600 mb-6">
          Your subscription has expired. Please renew your subscription to
          continue using all features of the application.
        </p>
        <button className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-green-800 transition">
          Renew Subscription
        </button>
      </div>
    </div>
  );
};

export default SubscriptionRenewalPage;
